import { type FieldName } from '../../../../types/CardFieldName';
import { type Fields } from '../../../../types/Field';
import { type SquareCardFormProps } from './component';

interface getSquareCardFormPropsParams {
  fieldsToRender: FieldName[];
  onFieldBlur: (fieldName: FieldName) => void;
  onFieldFocus: (fieldName: FieldName) => void;
  fields: Fields;
}

export const getSquareCardFormProps = ({
  fieldsToRender,
  onFieldBlur,
  onFieldFocus,
  fields,
}: getSquareCardFormPropsParams): SquareCardFormProps['fields'] => {
  return fieldsToRender.map((fieldName): SquareCardFormProps['fields'][0] => {
    return {
      fieldName,
      state: fields[fieldName],
      props: { onBlur: () => onFieldBlur(fieldName), onFocus: () => onFieldFocus(fieldName) },
    };
  });
};
